var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-banner'),_vm._v(" "),_c('v-jintro1'),_vm._v(" "),_c('v-jintro2'),_vm._v(" "),_c('v-footpannel',{attrs:{"type":'1'}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-cccd9cde","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/home/home2.vue
// module id = null
// module chunks = 